import config from '../../config/config';

export const PAYOUT_BATCH_FAILURE = 'PAYOUT_BATCH/PAYOUT_BATCH_FAILURE';
export const PAYOUT_BATCH_LOAD = 'PAYOUT_BATCH/PAYOUT_BATCH_LOAD';
export const PAYOUT_BATCH_SUCCESS = 'PAYOUT_BATCH/PAYOUT_BATCH_SUCCESS';
export const PAYOUT_BATCH_REJECT_SUCCESS = 'PAYOUT_BATCH/PAYOUT_BATCH_REJECT_SUCCESS';
export const PAYOUT_BATCH_REJECT_FAILURE = 'PAYOUT_BATCH/PAYOUT_BATCH_REJECT_FAILURE';
export const PAYOUT_BATCH_REJECT_LOAD = 'PAYOUT_BATCH/PAYOUT_BATCH_REJECT_LOAD';
export const PAYOUT_BATCH_APPROVE_SUCCESS = 'PAYOUT_BATCH/PAYOUT_BATCH_APPROVE_SUCCESS';
export const PAYOUT_BATCH_APPROVE_FAILURE = 'PAYOUT_BATCH/PAYOUT_BATCH_APPROVE_FAILURE';
export const PAYOUT_BATCH_APPROVE_LOAD = 'PAYOUT_BATCH/PAYOUT_BATCH_APPROVE_LOAD';

export function getPayoutBatch(batchId) {
    return {
        failureActionTypeOrCreator: getPayoutBatchFailureActionCreator,
        fetchParams: {
            url: `${config.payoutApiUrl}/batch/${batchId}`
        },
        loadActionTypeOrCreator: PAYOUT_BATCH_LOAD,
        successActionTypeOrCreator: getPayoutBatchSuccessActionCreator
    };
}

export function getPayoutBatchFailureActionCreator(error) {
    return {
        error,
        type: PAYOUT_BATCH_FAILURE
    };
}

export function getPayoutBatchSuccessActionCreator(payoutBatch) {
    return {
        payoutBatch,
        type: PAYOUT_BATCH_SUCCESS
    };
}

export function rejectPayoutBatch(batchId) {
    return {
        failureActionTypeOrCreator: rejectPayoutBatchFailureActionCreator,
        fetchParams: {
            method: 'PUT',
            url: `${config.payoutApiUrl}/batch/review`,
            body: {
                payoutBatchId: batchId,
                action: 'CANCEL'
            }
        },
        loadActionTypeOrCreator: PAYOUT_BATCH_REJECT_LOAD,
        successActionTypeOrCreator: rejectPayoutBatchSuccessActionCreator
    };
}

export function rejectPayoutBatchFailureActionCreator(error) {
    return {
        error,
        type: PAYOUT_BATCH_REJECT_FAILURE
    };
}

export function rejectPayoutBatchSuccessActionCreator() {
    return {
        type: PAYOUT_BATCH_REJECT_SUCCESS
    };
}

export function approvePayoutBatch(batchId) {
    return {
        failureActionTypeOrCreator: approvePayoutBatchFailureActionCreator,
        fetchParams: {
            method: 'PUT',
            url: `${config.payoutApiUrl}/batch/review`,
            body: {
                payoutBatchId: batchId,
                action: 'APPROVE'
            }
        },
        loadActionTypeOrCreator: PAYOUT_BATCH_APPROVE_LOAD,
        successActionTypeOrCreator: approvePayoutBatchSuccessActionCreator
    };
}

export function approvePayoutBatchFailureActionCreator(error) {
    return {
        error,
        type: PAYOUT_BATCH_APPROVE_FAILURE
    };
}

export function approvePayoutBatchSuccessActionCreator() {
    return {
        type: PAYOUT_BATCH_APPROVE_SUCCESS
    };
}
